import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchCommentarySnippetItem } from './SearchCommentarySnippetItem';
import { Connect, PropsFromRedux } from './SearchCommentarySnippetContainer';
import { ResultsType } from '../../../../state/reducers/results.types';
import { SearchCommentarySnippetSeeMore } from './SearchCommentarySnippetSeeMore';
import { AsideSearchSnippetHeader } from '../../aside/header/AsideSearchSnippetHeader';
import styles from './search_commentary_snippet.module.scss';

type Props = PropsFromRedux & {
  commentaries: NonNullable<ResultsType['snippets']['commentaries']>;
};

const RawSearchCommentarySnippet: FC<Props> = ({
  commentaries,
  query,
  onSeeMore,
}) => {
  return (
    <div className={styles.container}>
      <AsideSearchSnippetHeader
        title={
          <FormattedMessage id="search/components/search-snippets/main/commentary/SearchCommentarySnippet.tsx/2" />
        }
      >
        <SearchCommentarySnippetSeeMore
          commentaries={commentaries}
          query={query}
          onSeeMore={onSeeMore}
        />
      </AsideSearchSnippetHeader>
      {commentaries.map((commentary, index) => (
        <SearchCommentarySnippetItem
          index={index}
          key={commentary.commentaireId}
          commentary={commentary}
        />
      ))}
    </div>
  );
};

export const SearchCommentarySnippet = Connect(RawSearchCommentarySnippet);
